import React from 'react';
import { useClassName } from '../hooks';
import './Pane.scss';

type PaneProps = {
  className?: string;
  fullWidth?: boolean;
};

const Pane: React.FC<React.PropsWithChildren<PaneProps>> = ({
  children,
  className,
  fullWidth = false
}) => {
  const cx = useClassName('tk-pane', className, { 'full-width': fullWidth });

  return <div className={cx}>{children}</div>;
};

export default Pane;
